import imageRotateIcon from '../../images/icons/image-rotate-icon.svg';
import CustomTooltip from '../common/Tooltip';
import styles from '../../pages/ProductSelection.module.css';
import useProductSelectionStore from '../../stores/useProductSelectionStore';

const PhotoPagination = ({ onRotate }) => {
  const { photos, selectedPhoto, productType, photosLoadingMessage, handleSelectedPhoto } = useProductSelectionStore();

  if (photosLoadingMessage || !selectedPhoto?.attributes) return null;

  return (
    <div className={styles.paginationControlsContainer}>
      {photos.length > 1 && productType !== 'default' && (
        <div className={styles.paginationNumbers}>
          {photos.map((photo, index) => {
            const isActive = selectedPhoto?.id === photo.id;
            return (
              <button
                key={photo.id}
                type="button"
                onClick={() => handleSelectedPhoto(photo)}
                aria-label={`Show slide ${index + 1} of ${photos.length}`}
                aria-pressed={isActive}
                className={`${styles.paginationButton} ${isActive ? styles.paginationButtonActive : styles.paginationButtonInactive}`}
              >
                {index + 1}
              </button>
            );
          })}
        </div>
      )}

      <CustomTooltip title="Rotate Image">
        <button 
          type="button" 
          aria-label="Rotate Crop Orientation" 
          className={`rotate-button ${styles.rotateButtonStyled}`}
          onClick={onRotate}
        >
          <img 
            src={imageRotateIcon} 
            alt="Rotate" 
            className={styles.rotateIconImage}
          />
        </button>
      </CustomTooltip>
    </div>
  );
};

export default PhotoPagination;
